import styled from 'styled-components';

import { Text } from '@/nova/components/Text/Text';
import { COLORS, SPACE } from '@/nova/theme/tokens';

/* The stats sheet's footer: the asset's tracking links, read-only (the composer's tracking-link panel draws the copy
   field and the "Goes to" line; this reuses its styles by import). */

/** How tall the links list may grow once every link shows: past it the list scrolls inside the footer, so the sheet
 *  keeps its figures in view. Layout. */
const LIST_MAX_H = '40vh';

/** Fills the Sheet footer's row (which lays its children out to the end). */
export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[12]};
  flex: 1 1 auto;
  min-width: 0;
  max-height: ${LIST_MAX_H};
  overflow-y: auto;
`;

/** One link: its label, the copy field, then where it goes. */
export const LinkRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
  min-width: 0;
`;

/** No link yet: where to get one. */
export const Hint = styled(Text).attrs({ tag: 'span' as const })`
  font-size: 13px;
  color: ${COLORS.textMuted};
`;

/** "Show all N links" under the first rows. */
export const ShowAll = styled.button`
  align-self: flex-start;
  padding: ${SPACE[0]};
  border: 0;
  background: transparent;
  color: ${COLORS.accent};
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
